export default [
  // ------我创建的纪念馆------
  // {
  //     path: '/Personal/Hall/MyCreated',
  //     component: () => import('@/views/PersonalCenter/Hall/Manage/Index'),
  //     name: 'manageHallList',
  //     meta: {
  //         title: '我创建的',
  //         noCache: true,
  //         affix: true,
  //         requireAuth: true
  //     }
  // },
  // ------我关注的纪念馆------
  {
    path: '/Personal/Hall/MyFollow',
    component: () => import('@/views/PersonalCenter/Follow/Index'),
    name: 'Follow',
    meta: {
      title: '我关注的',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  // ------创建纪念馆------
  {
    path: '/Personal/Hall/Create/First',
    component: () => import('@/views/PersonalCenter/Hall/Create/First'),
    name: 'createNewHall',
    meta: {
      title: '创建纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Create/Second',
    component: () => import('@/views/PersonalCenter/Hall/Create/Second'),
    name: 'createNewHallTwo',
    meta: {
      title: '创建纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Create/Music',
    component: () => import('@/views/PersonalCenter/Hall/Create/Music'),
    name: 'createNewHallMusic',
    meta: {
      title: '创建纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Create/Indoor',
    component: () => import('@/views/PersonalCenter/Hall/Create/Indoor'),
    name: 'createNewHallIndoor',
    meta: {
      title: '创建纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Create/Outdoor',
    component: () => import('@/views/PersonalCenter/Hall/Create/Outdoor'),
    name: 'createNewHallOutdoor',
    meta: {
      title: '创建纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Create/Theme',
    component: () => import('@/views/PersonalCenter/Hall/Create/Theme'),
    name: 'createNewHallTheme',
    meta: {
      title: '创建纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Create/CommentTemp',
    component: () => import('@/views/PersonalCenter/Hall/Create/CommentTemp'),
    name: 'CommentTemp',
    meta: {
      title: '创建纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Create/Success/:id',
    component: () => import('@/views/PersonalCenter/Hall/Create/Success'),
    name: 'HallCreateSuccess',
    meta: {
      title: '创建纪念馆成功',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  // ------管理纪念馆------
  {
    path: '/Personal/Hall/Manage/List',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Index'),
    name: 'manageHallList',
    meta: {
      title: '纪念馆管理',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/Info/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Info'),
    name: 'manageHallInfo',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/Relative/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Relative'),
    name: 'manageHallRelative',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/RelativeTwo/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/RelativeTwo'),
    name: 'manageHallRelativeTwo',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/RelativeSuccess',
    component: () =>
      import('@/views/PersonalCenter/Hall/Manage/RelativeSuccess'),
    name: 'manageHallRelativeSuccess',
    meta: {
      title: '亲友管理',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/Level',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Level'),
    name: 'manageHallLevel',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Article/List/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Article/Index'),
    name: 'manageHallArticleList',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Article/Detail/:id',
    component: () =>
      import('@/views/PersonalCenter/Hall/Manage/Article/Detail'),
    name: 'manageHallArticleDetail',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Article/Create/:id',
    component: () =>
      import('@/views/PersonalCenter/Hall/Manage/Article/Create'),
    name: 'manageHallArticleCreate',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Message/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Message/Index'),
    name: 'manageHallMessage',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Message/Setup/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Message/Setup'),
    name: 'manageHallMessageSetup',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Article/Edit/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Article/Edit'),
    name: 'manageHallArticleEdit',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Album/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Album/Index'),
    name: 'manageHallAlbum',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Album/Create/:hallId/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Album/Create'),
    name: 'manageHallAlbumCreate',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Album/Upload/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Album/Upload'),
    name: 'manageHallAlbumUpload',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Album/Edit/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Album/Edit'),
    name: 'manageHallAlbumEdit',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  // 转交纪念馆
  {
    path: '/Personal/Hall/Manage/Transfer/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Transfer'),
    name: 'manageForward',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  // 删除纪念馆
  {
    path: '/Personal/Hall/Manage/Delete/:id',
    component: () => import('@/views/PersonalCenter/Hall/Manage/Delete'),
    name: 'manageDelete',
    meta: {
      title: '管理纪念馆',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  // 讣告管理
  {
    path: '/Personal/Hall/Manage/Obituary/Fill/:id',
    component: () => import('@/views/Obituary/Fill'),
    name: 'ObituaryFill',
    meta: {
      title: '讣告',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/Obituary/Temp',
    component: () => import('@/views/Obituary/TempSelect'),
    name: 'TempSelect',
    meta: {
      title: '模板选择',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/Obituary/SignGroup/List',
    component: () => import('@/views/Obituary/SignGroupList'),
    name: 'SignGroupList',
    meta: {
      title: '署名组',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/Obituary/SignGroup/Edit',
    component: () => import('@/views/Obituary/SignGroupEdit'),
    name: 'SignGroupEdit',
    meta: {
      title: '署名组',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/Obituary/FillFinish',
    component: () => import('@/views/Obituary/FillFinish'),
    name: 'ObituaryFillFinish',
    meta: {
      title: '讣告',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Hall/Manage/Obituary/download',
    component: () => import('@/views/Obituary/DownloadImage'),
    name: 'DownloadImage',
    meta: {
      title: '下载讣告',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  }
]
